/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespShippingReturns_viewer = {|
  +isItemInvoiceEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPayments_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isItemInvoiceEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "INVOICE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"INVOICE\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
